import type { ApiEmployeeCompensationPerTypes } from "@/types/employees/employee-compensation.types.ts";

export enum ApiCompensationComponentKind {
  earning = "earning",
  deduction = "deduction",
  employer_contribution = "employer_contribution",
}

export const BASIC_SALARY_COMPENSATION_COMPONENT_CODE = "basic_salary";

export interface ApiCompensationComponent {
  id: number;
  title: string;
  sort: number;
  code: string | null;
  is_system: boolean;
  kind: ApiCompensationComponentKind;
  is_included_in_gross: boolean;
  is_payable_to_employee: boolean;
  is_included_in_total_cost: boolean;
  is_off_payroll: boolean;
  is_statutory_base: boolean;
  default_per_type: ApiEmployeeCompensationPerTypes | null;
  default_currency_code: string | null;
  legacy_organization_list_item_id: number | null;
  is_archived: boolean;
}

export type ApiCompensationComponentShort = Pick<
  ApiCompensationComponent,
  "id" | "title" | "sort" | "is_archived"
>;

export type ApiCompensationComponentPayload = Pick<
  ApiCompensationComponent,
  | "title"
  | "sort"
  | "kind"
  | "is_included_in_gross"
  | "is_payable_to_employee"
  | "is_included_in_total_cost"
  | "is_off_payroll"
  | "is_statutory_base"
  | "default_per_type"
  | "default_currency_code"
>;

export const canArchiveCompensationComponent = (component: ApiCompensationComponent) =>
  !component.is_system;
